export const calculateOffset = (actual, wanted, total) => {
  const shift = Math.floor(total / 2);
  const current = actual - wanted + shift;
  return (((current % total) + total) % total) - shift;
};

export const getNavigationBarPath = (pathGenerator, path, missionSlug) =>
  pathGenerator(path, { missionSlug });
